import React from "react";
import { VerticalTimeline, VerticalTimelineElement } from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FaCheckCircle } from "react-icons/fa";
import { motion } from "framer-motion";
import '../styles/lines.css';

const DedicatedTeamsTimeline = () => {
    const steps = [
        {
            title: "STEP ONE",
            subtitle: "Dedicated Team Brief",
            description: "We sit down with you to discuss your long-term vision and the key profiles and skills you’re looking for in a dedicated team of software developers. If you have deliverables that need to be implemented urgently, we can refer you to our Project Team while we search for your dedicated team.",
           
        },
        {
            title: "STEP TWO",
            subtitle: "Candidate Screening",
            description: "We begin screening our shortlist of top talent for your dedicated team. Then, we discuss their profiles with you to ensure they’re the right fit. Then you carry out the final interviews and together we begin the onboarding process.",
        },
        {
            title: "STEP THREE",
            subtitle: "Onboarding",
            description: "We assist you with onboarding your dedicated team. If our Project Team is helping you with deliverables, we will carry out our knowledge transfer process to hand over the reins to your dedicated team.",
        },
        {
            title: "Step Four",
            subtitle: "Management and Scaling",
            description: "Run a dedicated team of software developers, with the help of your Scrum Team. At this point, we also change and expand your dedicated team according to your project’s needs.",
        },
    ];

    return (
        <motion.div
            className="p-8 bg-gray-100 min-h-screen flex justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
        >
            <VerticalTimeline>
                {steps.map((step, index) => (
                    <VerticalTimelineElement
                        key={index}
                        className="vertical-timeline-element--work"
                        contentStyle={{
                            background: "#fff",
                            color: "#333",
                            boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.25)",
                        }}
                        contentArrowStyle={{ borderRight: "7px solid #fff" }}
                        iconStyle={{ background: "#037AC0", color: "#fff" }}
                        icon={<FaCheckCircle />}
                        position={index % 2 === 0 ? "left" : "right"}
                    >
                        <h3 className="text-xl font-bold text-[#037AC0] font-poppins">{step.title}</h3>
                        <h4 className="text-2xl font-bold mt-2 font-poppins">{step.subtitle}</h4>
                        <p className="mt-2 text-gray-600 font-poppins">{step.description}</p>
                       
                    </VerticalTimelineElement>
                ))}
            </VerticalTimeline>
        </motion.div>
    );
};

export default DedicatedTeamsTimeline;
